import type { LegendItem } from './RadarLegend.types';

export const TEXT_LABELS: LegendItem[] = [
  {
    key: 'light',
    getLabel: (t) => t('map.layers.radar.legend.light'),
    isLight: true,
  },
  {
    key: 'steady',
    getLabel: (t) => t('map.layers.radar.legend.steady'),
    isLight: false,
  },
  {
    key: 'heavy',
    getLabel: (t) => t('map.layers.radar.legend.heavy'),
    isLight: false,
  },
  {
    key: 'intense',
    getLabel: (t) => t('map.layers.radar.legend.intense'),
    isLight: false,
  },
  {
    key: 'extreme',
    getLabel: (t) => t('map.layers.radar.legend.extreme'),
    isLight: false,
  },
];

export const RATE_LABELS: LegendItem[] = [
  {
    key: 'rate-0.01',
    getLabel: (t) => t('map.layers.radar.legend.rateValue', { value: '0.01' }),
    isLight: true,
  },
  { key: 'rate-0.07', getLabel: () => '0.07', isLight: true },
  { key: 'rate-0.05', getLabel: () => '0.05', isLight: false },
  { key: 'rate-0.22', getLabel: () => '0.22', isLight: false },
  { key: 'rate-0.92', getLabel: () => '0.92', isLight: false },
  { key: 'rate-4.00', getLabel: () => '4.00', isLight: false },
  { key: 'rate-16.0+', getLabel: () => '16.0+', isLight: false },
];

export const DBZ_LABELS: LegendItem[] = [
  {
    key: 'dBZ-5',
    getLabel: (t) => t('map.layers.radar.legend.dbzValue', { value: '5' }),
    isLight: true,
  },
  { key: 'dBZ-15', getLabel: () => '15', isLight: true },
  { key: 'dBZ-25', getLabel: () => '25', isLight: false },
  { key: 'dBZ-35', getLabel: () => '35', isLight: false },
  { key: 'dBZ-45', getLabel: () => '45', isLight: false },
  { key: 'dBZ-55', getLabel: () => '55', isLight: false },
  { key: 'dBZ-65+', getLabel: () => '65+', isLight: false },
];
